module.exports = __webpack_public_path__ + "static/media/washington-dc-40.d78f4e16.jpg";